import { HttpParams } from '@angular/common/http';

export function buildHttpParams<T extends object>(filters?: T): HttpParams {
  let params = new HttpParams();

  if (!filters) {
    return params;
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      params = params.set(key, String(value));
    }
  });

  return params;
}
